import { cn } from '@/utils/cn';
const ListSkeleton = () => {
  return <div className='grid grid-cols-3 gap-1 lg:gap-2.5' data-sentry-component="ListSkeleton" data-sentry-source-file="list-skeleton.tsx">
            {Array(15).fill(null).map((_, index) => <div key={index} className={cn('aspect-square w-full animate-pulse rounded bg-gray-100', {
      'row-span-2 aspect-auto': index === 0 || index === 7
    })} />)}
        </div>;
};
export default ListSkeleton;